import { load } from 'cheerio';

export function extractKBSCategoryDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    let descriptionHtml = '';

    $('[id^="column_"]').each((_, el) => {
        const content = $(el).html();
        if (content) descriptionHtml += content;
    });

    return descriptionHtml;
}
